//目前使用行動裝置判斷
const agent       = navigator.userAgent;
const checkDevice = {
  ios    : agent.match(/iP(hone|od|ad)/i),
  android: agent.match(/Android/i)
};




//iOS(iPad, iPhone) Meta Viewport 鎖定縮放拖曳
class IosFixed {
  metaViewport() {
    if (checkDevice.ios || checkDevice.android) {
      document.documentElement.addEventListener('touchstart', (event) => {
        if (event.touches.length > 1) {
          event.preventDefault();
        }
      }, false);

      let lastTouchEnd = 0;
      document.documentElement.addEventListener('touchend', (event) => {
        let now = (new Date()).getTime();
        if (now - lastTouchEnd <= 300) {
          event.preventDefault();
        }
        lastTouchEnd = now;
      }, false);
    }
  }
}




//CSS Transition & Animation 結束判斷
const transitionEnd = 'webkitTransitionEnd oTransitionEnd msTransitionEnd transitionend';
const animationEnd  = 'webkitAnimationEnd oAnimationEnd msAnimationEnd animationend';




//輸出
export {checkDevice, IosFixed, transitionEnd, animationEnd};


// WEBPACK FOOTER //
// ./js_new/common.js